import React from 'react';
import InfoTip from '../../../components/InfoTip';
import { Clic, BROWN } from './commun';
import { Sparkline } from './Graphiques';

// Carte indicateur : valeur, variation vs période précédente, mini-courbe journalière, clic = liste.
// sensInverse : une hausse est mauvaise (ex. réparations) → variation colorée en rouge.
export const KpiDelta = ({ titre, valeur, actuel, precedent, serie, couleur = BROWN, info, onClick, sensInverse, comparer }) => {
  const variation = comparer && precedent > 0 ? Math.round(((actuel - precedent) * 100) / precedent) : null;
  const bon = variation == null ? null : (sensInverse ? variation <= 0 : variation >= 0);
  return (
    <div className="col-6 col-md-4 col-xl mb-3">
      <div style={{ border: '1px solid #e0d6c8', borderTop: `4px solid ${couleur}`, borderRadius: 12, padding: '10px 14px', background: '#fff', height: '100%' }}>
        <div style={{ fontSize: '0.72rem', color: '#888', textTransform: 'uppercase', fontWeight: 700, letterSpacing: 0.4 }}>
          {titre} {info && <InfoTip text={info} />}
        </div>
        <div style={{ fontSize: '1.45rem', fontWeight: 800, color: couleur, lineHeight: 1.2 }}><Clic onClick={onClick}>{valeur}</Clic></div>
        <div style={{ fontSize: '0.75rem', minHeight: 18, color: bon == null ? '#999' : bon ? '#2e7d32' : '#c62828', fontWeight: 600 }}>
          {variation == null ? (comparer ? '— vs période préc.' : '') : `${variation > 0 ? '▲ +' : variation < 0 ? '▼ ' : '= '}${variation} % vs période préc.`}
        </div>
        <Sparkline valeurs={serie} couleur={couleur} />
      </div>
    </div>
  );
};

const lvColor = (s) => (s >= 80 ? '#2e7d32' : s >= 50 ? '#e65100' : '#b71c1c');
const note = (p) => (p >= 90 ? ['👏', 'Excellence'] : p >= 80 ? ['👍', 'Bon travail'] : p >= 50 ? ['🤏', 'Peut mieux'] : ['👎', 'Alerte']);

// Bandeau santé : score v2 + axes + alertes cliquables (ouvrent la liste correspondante)
export const SanteBanner = ({ sante, onListe }) => {
  if (!sante) return null;
  const g = sante.score.global;
  const [emoji, label] = note(g);
  return (
    <div style={{ background: '#fff', border: '1px solid rgba(109,78,54,0.15)', borderRadius: 12, padding: '10px 14px', marginBottom: 16,
      boxShadow: '0 2px 8px rgba(109,78,54,0.06)' }}>
      <div className="d-flex flex-wrap align-items-center gap-2">
        <div style={{ border: `2px solid ${lvColor(g)}`, color: lvColor(g), borderRadius: 10, padding: '4px 12px', fontWeight: 800 }}>
          {emoji} Santé {g}/100 · {label}
        </div>
        <InfoTip text="Moyenne pondérée de 5 taux notés sur 100 (état au dernier jour saisi). Chaque taux remonte dès que la situation s'améliore." />
        {sante.score.axes.map(a => (
          <span key={a.code} title={a.info}
            style={{ background: `${lvColor(a.score)}14`, color: lvColor(a.score), borderRadius: 20, padding: '2px 10px', fontSize: '0.76rem' }}>
            ● {a.label} <strong>{a.score} %</strong> <small>({a.valeur}/{a.total}) ×{a.w}</small>
          </span>
        ))}
      </div>
      {sante.alertes.length > 0 && (
        <div className="d-flex flex-wrap gap-2 mt-2">
          {sante.alertes.map(a => (
            <button key={a.code} type="button" onClick={() => onListe(a.liste, `${a.nb} ${a.label}`, a.filtre)}
              className="btn btn-sm" style={{
                background: a.niveau === 'rouge' ? '#fdecea' : '#fff4e5', color: a.niveau === 'rouge' ? '#b71c1c' : '#b45309',
                border: `1px solid ${a.niveau === 'rouge' ? '#f5c2c0' : '#fcd9a8'}`, fontSize: '0.8rem', fontWeight: 600,
              }}>
              {a.niveau === 'rouge' ? '🔴' : '🟠'} {a.nb} {a.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
